import { render, staticRenderFns } from "./RightsStatementButton.vue?vue&type=template&id=4daef65b&scoped=true&"
import script from "./RightsStatementButton.vue?vue&type=script&lang=js&"
export * from "./RightsStatementButton.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./RightsStatementButton.vue?vue&type=style&index=0&id=4daef65b&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4daef65b",
  "4613b56e"
  
)

export default component.exports